import { render, staticRenderFns } from "./SubjectsClosed.vue?vue&type=template&id=df20185e&"
import script from "./SubjectsClosed.vue?vue&type=script&lang=js&"
export * from "./SubjectsClosed.vue?vue&type=script&lang=js&"
import style0 from "./SubjectsClosed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports